import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import {
  function_PRO_Articulos_BOM_Listar,
  function_PRO_Articulos_BOM_Generar_JSON,
  function_PRO_Articulos_BOM_Insertar,
  function_PRO_Articulos_BOM_Eliminar,
  function_PRO_Articulos_BOM_LeerNecesidadesDeProduccion
} from "neftis7_apicaller/src/funciones/PRO/PRO_Articulos_BOM";
import { CheckBox, LoadPanel, NumberBox, TextBox, TreeList } from "devextreme-react";
import { Column, FilterPanel, FilterRow, SearchPanel } from "devextreme-react/data-grid";
import { Export } from "devextreme-react/bar-gauge";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import ComboAbmArtArticulos from "../../Componentes/Compuestos/Combos/ComboAbmArtArticulos";

export const PRO_Articulos_BOM = () => {

  let Codigo = useParams()

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)

  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState(false);
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState(false);
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState(false);
  const [filtroVendible, setFiltroVendible] = useState(true);
  const [filtroNoVendible, setFiltroNovendible] = useState(false);
  const [actualizarArbol, setActualizarArbol] = useState(true);
  const [arbol, setArbol] = useState([]);
  const [filtroCodigo, setFiltroCodigo] = useState([]);
  const [filtroDescripcion, setFiltroDescripcion] = useState([]);
  const [cantidad, setCantidad] = useState(0);

  const [nodoSeleccionado, setNodoSeleccionado] = useState(null);
  const [articuloSeleccionado, setArticuloSeleccionado] = useState(null);
  const [articuloPadreSeleccionadoCreacionBOM, setArticuloPadreSeleccionadoCreacionBOM] = useState(null);
  const [articuloHijoSeleccionadoCreacionBOM, setArticuloHijoSeleccionadoCreacionBOM] = useState(null);
  const [cantidadCreacionBOM, setCantidadCreacionBOM] = useState(1);
  const [comprables, setComprables] = useState([]);
  const [importeTotal, setImporteTotal] = useState(0);

  const getData = async () => {
    setLoading(true);
    try {
      let filtro = ""
      if (filtroCodigo !== "") {
        filtro = filtro + " AND PRO_Articulos_BOM.CodigoArticuloPadre like '%" + filtroCodigo + "%'"
      }
      if (filtroDescripcion !== "") {
        filtro = filtro + " AND ArticulosPadre.Descripcion like '%" + filtroDescripcion + "%'"
      }

      if (filtroVendible && filtroNoVendible) { }
      else {
        if (filtroVendible) {
          filtro = filtro + " AND ArticulosPadre.Vendible = 1 "
        }
        else {
          filtro = filtro + " AND ArticulosPadre.Vendible = 0 "
        }
      }

      const resultBOM = await function_PRO_Articulos_BOM_Listar(filtro);
      setArbol(resultBOM.data);
      setLoading(false);
    } catch (error) {
      alert("Error al cargar los datos: " + error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getData();
  }, [filtroCodigo, filtroDescripcion, filtroVendible, filtroNoVendible]);

  const handleSeleccionarNodo = async (e) => {
    const nodo = e.data;
    setNodoSeleccionado(nodo);

    try {

      const data = await function_PRO_Articulos_BOM_LeerNecesidadesDeProduccion(
        nodo.CodigoArticulo,
        nodo.CodigoTamano,
        nodo.CodigoPresentacion,
        nodo.CodigoUnidadMedida,
        ""
      );

      const lista = data.data.Comprables || [];
      const total = lista.reduce((acc, item) => acc + (item.ImporteTotalSugerido || 0), 0);

      setComprables(lista);
      setImporteTotal(total);
    } catch (error) {
      alert("Error al calcular necesidades: " + error.message);
      setComprables([]);
      setImporteTotal(0);
    }
  };

  const handleEliminarNodo = async () => {
    if (!nodoSeleccionado) return alert("Selecciona un nodo primero.");

    const confirmacion = window.confirm(`¿Seguro que deseas eliminar el nodo "${nodoSeleccionado.Articulo}"?`);
    if (confirmacion) {
      try {
        await function_PRO_Articulos_BOM_Eliminar(nodoSeleccionado.IdItem);
        setNodoSeleccionado(null);
        if (actualizarArbol) {
          getData(); // Recargar datos
        }
      } catch (error) {
        alert("Error al eliminar el nodo: " + error.message);
      }
    }
  };

  const handleAgregarSubnivel = async () => {
    if (!nodoSeleccionado) return alert("Selecciona un nodo primero.");
    if (!articuloSeleccionado) return alert("Selecciona un artículo.");
    if (cantidad <= 0) return alert("La cantidad debe ser mayor a 0.");

    try {
      const JSON = await function_PRO_Articulos_BOM_Generar_JSON(nodoSeleccionado.CodigoArticulo,
        nodoSeleccionado.CodigoPresentacion, nodoSeleccionado.CodigoTamano, nodoSeleccionado.CodigoUnidadMedida,
        articuloSeleccionado,
        "DEF", "DEF", "UN",
        cantidad, null, null, null)

      await function_PRO_Articulos_BOM_Insertar(JSON);

      setArticuloSeleccionado(null);
      setCantidad(1);
      if (actualizarArbol) {
        getData(); // Recargar datos
      }
    } catch (error) {
      console.log(error)
      alert("Error al agregar subnivel: " + error.message);
    }
  };

  const handleOnClick_AgregarBOM = async () => {
    if (!articuloPadreSeleccionadoCreacionBOM) return alert("Selecciona un Artículo Padre.");
    if (!articuloHijoSeleccionadoCreacionBOM) return alert("Selecciona un Artículo Hijo.");
    if (cantidadCreacionBOM <= 0) return alert("La cantidad debe ser mayor a 0.");

    try {
      const JSON = await function_PRO_Articulos_BOM_Generar_JSON(articuloPadreSeleccionadoCreacionBOM,
        "DEF", "DEF", "UN",
        articuloHijoSeleccionadoCreacionBOM,
        "DEF", "DEF", "UN",
        cantidadCreacionBOM, null, null, null)

      await function_PRO_Articulos_BOM_Insertar(JSON);

      setArticuloPadreSeleccionadoCreacionBOM(null);
      setArticuloHijoSeleccionadoCreacionBOM(null);
      setCantidadCreacionBOM(1);
      getData(); // Recargar datos
    } catch (error) {
      console.log(error)
      alert("Error al agregar subnivel: " + error.message);
    }
  };

  return (
    <PaginaCarga Titulo="LISTAS DE MATERIALES">
      <div
        className="LV-GroupBox-div"
        style={{ marginBottom: "10px", marginTop: "10px", alignItems: "center" }}
      >
        <div className="LV-FlexContainer" style={{ gap: 30, marginTop: 20 }}>
          <TextBox label="Filtro Código" text={filtroCodigo} width={200} onValueChanged={(e) => setFiltroCodigo(e.value)} />
          <TextBox label="Filtro Descripción" text={filtroDescripcion} width={400} onValueChanged={(e) => setFiltroDescripcion(e.value)} />
          <CheckBox text="VENDIBLES" value={filtroVendible} onValueChanged={(e) => setFiltroVendible(e.value)} />
          <CheckBox text="NO VENDIBLES" value={filtroNoVendible} onValueChanged={(e) => setFiltroNovendible(e.value)} />

          <div className="LV-GroupBox-div " style={{ display: "flex", flexDirection: "column", gap: 30, marginTop: 20 }}>
            Creación de Lista de Producción
            <ComboAbmArtArticulos Fabricables={true} Vendibles={true} CampoDescripcion={"CodigoDescripcion"} ancho="300" value={articuloPadreSeleccionadoCreacionBOM} onValueChanged={(e) => setArticuloPadreSeleccionadoCreacionBOM(e.value)} />
            <ComboAbmArtArticulos CampoDescripcion={"CodigoDescripcion"} ancho="300" value={articuloHijoSeleccionadoCreacionBOM} onValueChanged={(e) => setArticuloHijoSeleccionadoCreacionBOM(e.value)} />
            <NumberBox label="Cantidad" text={cantidadCreacionBOM} width={200} onValueChanged={(e) => setCantidadCreacionBOM(e.value)} />
            <LVButtonAccion Texto={"AGREGAR"} onClick={handleOnClick_AgregarBOM} />
          </div>
        </div>

        <div className="LV-FlexContainer" style={{ gap: 30, marginTop: 20, marginBottom: 20 }}>
          {loading ? (
            <p>Cargando datos...</p>
          ) : (
            <>
              <div style={{ marginTop: 20, width: "100%" }}>
                <TreeList
                  dataSource={arbol}
                  columnAutoWidth={true}
                  itemsExpr="Hijos"
                  dataStructure="tree"
                  onRowClick={handleSeleccionarNodo}
                >
                  <SearchPanel visible={true} />
                  <FilterPanel visible={true} />
                  <FilterRow visible={true} />
                  <Export enabled={true} allowExportSelectedData={true} />
                  <LoadPanel enabled={true} />

                  <Column caption="Artículo" alignment="Center">
                    <Column caption="Código" dataField="CodigoArticulo" width="200" alignment="Left" dataType="string" />
                    <Column dataField="IdItem" caption="Item" />
                    <Column dataField="Cantidad" caption="Cantidad" />
                    <Column caption="Descripción" dataField="Articulo" width="100%" minWidth={200} alignment="Left" dataType="string" />
                  </Column>

                  <Column caption="Presentación" alignment="Center" visible={globalUsaArticulosConPresentacion}>
                    <Column caption="Código" dataField="CodigoPresentacion" width="200" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Presentacion" width="200" alignment="Left" dataType="string" />
                  </Column>

                  <Column caption="Tamaño" alignment="Center" visible={globalUsaArticulosConTamano}>
                    <Column caption="Código" dataField="CodigoTamano" width="200" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Tamano" width="200" alignment="Left" dataType="string" />
                  </Column>

                  <Column caption="Unidad de Medida" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida}>
                    <Column caption="Código" dataField="CodigoUnidadMedida" width="200" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="UnidadMedida" width="200" alignment="Left" dataType="string" />
                  </Column>
                </TreeList>
              </div>

              {nodoSeleccionado && (
                <div className="LV-GroupBox-div" style={{ width: "800px", gap: "10px", marginRight: "20px" }}>
                  <div style={{ width: "95%", justifyItems: "center", marginBottom: "20px", marginLeft: "10px", marginRight: "10px" }}>
                    <h3>Artículo seleccionado: {nodoSeleccionado.Articulo}</h3>
                  </div>

                  <div style={{ width: "95%", justifyItems: "center", marginBottom: "20px", marginLeft: "10px", marginRight: "10px" }}>
                    <LVButtonAccion Texto="ELIMINAR NODO" onClick={handleEliminarNodo} />
                  </div>

                  <div className="LV-GroupBox-div" style={{ width: "95%", justifyItems: "center", marginBottom: "20px", marginLeft: "10px", marginRight: "10px", padding: "20px" }}>
                    <ComboAbmArtArticulos
                      value={articuloSeleccionado}
                      CampoDescripcion="CodigoDescripcion"
                      ancho="400"
                      onValueChanged={(e) => setArticuloSeleccionado(e.value)}
                    />

                    <br />

                    <NumberBox
                      value={cantidad}
                      min={0}
                      label="Cantidad"
                      onValueChanged={(e) => setCantidad(e.value)}
                      width={100}
                    />

                    <br />

                    <LVButtonAccion Texto="AGREGAR" onClick={handleAgregarSubnivel} />
                    <CheckBox text="ACTUALIZAR ÁRBOL" value={actualizarArbol} onValueChanged={(e) => setActualizarArbol(e.value)} />
                  </div>

                  {comprables.length > 0 && (
                    <div style={{ marginTop: "40px", padding: "20px", border: "1px solid #ccc", borderRadius: "10px" }}>
                      <h3>Artículos Comprables</h3>
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                          <tr>
                            <th style={{ borderBottom: "1px solid #ccc", textAlign: "left", padding: "8px" }}>Código</th>
                            <th style={{ borderBottom: "1px solid #ccc", textAlign: "left", padding: "8px" }}>Descripción</th>
                            <th style={{ borderBottom: "1px solid #ccc", textAlign: "left", padding: "8px" }}>Cantidad</th>
                            <th style={{ borderBottom: "1px solid #ccc", textAlign: "right", padding: "8px" }}>Importe Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {comprables.map((item, idx) => (
                            <tr key={idx}>
                              <td style={{ padding: "8px" }}>{item.CodigoArticulo}</td>
                              <td style={{ padding: "8px" }}>{item.Articulo}</td>
                              <td style={{ padding: "8px" }}>{item.CantidadNecesaria}</td>
                              <td style={{ padding: "8px", textAlign: "right" }}>
                                ${item.ImporteTotalSugerido?.toFixed(2) || "0.00"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td></td>
                            <td style={{ padding: "8px", fontWeight: "bold" }}>Total</td>
                            <td style={{ padding: "8px", textAlign: "right", fontWeight: "bold" }}>
                              ${importeTotal.toFixed(2)}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </PaginaCarga>
  );
}
